<template>
  <v-dialog v-model="visible"
            persistent
            :max-width="'50%'">
    <v-layout v-if="itemDetail">
      <v-flex>
        <v-card>
          <v-card-title>促銷頁面管理</v-card-title>
          <v-card-text>
            <v-layout v-if="isEdit !== 'add'">
              <v-flex>
                {{ itemDetail.pageId }}
                <a :href="`https://www.innovision.com.tw/sale?pageId=${itemDetail.pageId}`" target="_blank">開啟連結</a>
              </v-flex>
            </v-layout>
            <v-layout v-for="col in getDialogKeys" :key="col.value">
              <v-flex>
                <br/><span class="title" v-if="col.editorOption">{{col.editorOption.placeholder}}</span><br/>
                <quill-editor v-if="col.value === 'content'"
                              class="mb-2 mt-2"
                              ref="myQuillEditor"
                              v-model="itemDetail[col.value]"
                              :options="col.editorOption"
                              @blur="onEditorBlur($event)"
                              @focus="onEditorFocus($event)"
                              @ready="onEditorReady($event)"
                />
                <v-text-field v-else v-model="itemDetail[col.value]"
                              :label="col.text"
                              :color="Theme.GREEN"></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout>
              <v-flex>
                <span class="title">購買連結</span>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex>
                <v-btn dark :color="Theme.GREEN" @click="addLink">新增</v-btn>
              </v-flex>
            </v-layout>
            <v-layout class="mt-2" row>
              <v-flex>
                <v-card v-for="(image, i) in itemDetail.linkList" :key="i" class="mt-1">
                  <v-card-text>
                    <v-text-field v-model="image.url"
                                  :label="`#${i+1} 網址`"
                                  :color="Theme.GREEN"></v-text-field>
                    <v-layout class="ma-1">
                      <v-flex xs6>
                        <v-text-field v-model="image.title"
                                      label="標題"
                                      :color="Theme.GREEN"></v-text-field>
                      </v-flex>
                      <v-flex xs6>
                        <v-btn :color="Theme.PINK" dark @click="deleteLink(i)">刪除</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

          </v-card-text>
          <v-card-actions>
            <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent">取消</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark :color="Theme.GREEN" :loading="saveLoading" @click="saveData">確定</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-dialog>

</template>

<script>
import common from "@/mixins/common";
import {mapActions} from 'vuex';

export default {
  name: "sale",
  mixins: [common],
  props: {
    visible: Boolean,
    showCancel: Boolean,
    itemDetail: Object,
    isEdit: String,
  },
  data(){
    return {
      // itemDetail: {
      //   pageId: '',
      //   title:'',
      //   content:'',
      //   imageURL:'',
      //   linkList:[],
      // },
      defaultLinkItem: {
        productId:'',
        title:'',
        url:'',
        createdDate: new Date(),
      },
      saveLoading: false,
    }
  },
  watch:{
    visible(value){
      if (value === true){
        this.loadData();
      }
      console.log(`key == ${this.key}`)
    }
  },
  created() {

  },
  mounted() {
    // console.log('this is current quill instance object', this.editor)
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    },
    getDialogKeys() {
      return [
        {value: 'title', text: '標題'},
        {value: 'content', text: '內容', editorOption: {
            placeholder:'內容'
          },},
        {value: 'imageURL', text: '圖片網址', editorOption: {
            placeholder:'圖片網址'
          },},
      ];
    },
  },
  methods: {
    ...mapActions(['getSaleInfo', 'saveSaleInfo']),
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      console.log('editor ready!', quill);
      quill.container.style.height = '500px';
    },
    onEditorChange({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
    },
    async loadData(){
      console.log(`loadData ${JSON.stringify(this.itemDetail)}`);

      this.loading = true;
      const res = await this.getSaleInfo({ pageId: this.itemDetail.pageId });

      if (res.data.code === 0){
        this.itemDetail = res.data.body;

        console.log(`getSaleInfo ${JSON.stringify(res.data.body)}`);
      }
      this.loading = false;
    },
    async saveData(){
      this.saveLoading = true;

      console.log(`save ${JSON.stringify(this.itemDetail)}`);
      const res = await this.saveSaleInfo({token: '', info: this.itemDetail});
      const result = res.data;
      if (result.code === 0) {
        this.showMessageDialog('成功', '儲存成功');
        this.$emit('successEvent');
      } else {
        this.showMessageDialog('錯誤', result.message ? result.message : '儲存失敗');
      }
      this.saveLoading = false;
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        showCancel: false,
        confirmEvent: async () => {
          this.hideAlert();
        }
      });
    },
    addLink(){
      const link = Object.assign({}, this.defaultLinkItem);
      link.productId = this.itemDetail.pageId;
      this.itemDetail.linkList.push(link);
    },
    deleteLink(i){
      this.itemDetail.linkList.splice(i, 1);
    },
    cancelEvent() {
      this.$emit('cancelEvent');
    },
  }
}
</script>

<style scoped>

</style>
